import { createContext, useContext } from 'react';
import type { SafeguardFlag } from '../hooks/useChat';

/**
 * Continue fresh (ADR-022) state for the active chat, provided once by the app
 * and read by ChatArea so the three shells that render a ChatArea (personal,
 * Writer's Room, film studio) need no extra prop plumbing. Absent provider =
 * feature off (tests, bare renders).
 */
export interface ContinueFreshValue {
  /** The live safeguard flag on this chat, if any. */
  flag: SafeguardFlag | null;
  /** A turn is streaming; the banner stays out of the way. */
  isLoading: boolean;
  /** The chat that continues this one, if it has been continued. */
  successor: { id: string; label: string | null } | null;
  onTryAgain: () => void;
  onContinueFresh: () => Promise<'ok' | 'rate_limited' | 'failed'>;
  onFollowSuccessor: () => void;
}

export const ContinueFreshContext = createContext<ContinueFreshValue | null>(null);

export function useContinueFresh(): ContinueFreshValue | null {
  return useContext(ContinueFreshContext);
}
